import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: true
    },
    locked: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: Number,
      default: 0
    },
    id: {
      type: String,
      required: true
    },
    group: {
      type: String
    },
    animation: {
      type: String,
      default: 'collapse'
    }
  },
  data: function data() {
    return {
      height: 'auto',
      overflow: "hidden",
      hide: true,
      animating: false
    };
  },
  computed: {
    collapseStore: function collapseStore() {
      return useCollapseStore();
    },
    isCollapsed: function isCollapsed() {
      var _this = this;
      if (this.locked) return true;
      if (process.server) return this.collapsed;
      return !this.collapseStore.collapsed.some(function (o) {
        return o.id == _this.id;
      });
    }
  },
  watch: {
    isCollapsed: function isCollapsed(val) {
      var _this2 = this;
      this.animating = true;
      this.updateHeight();
      if (!val && this.group) this.collapseStore.handleGroup({
        id: this.id,
        group: this.group
      });

      // Give browser time to set styles
      if (process.client) {
        setTimeout(function () {
          _this2.setHide(val);
        }, 20);
      } else {
        this.setHide(val);
      }
    }
  },
  created: function created() {
    this.hide = this.collapsed;
  },
  beforeMount: function beforeMount() {
    if (!this.collapsed) this.collapseStore.add(this.id);
  },
  mounted: function mounted() {
    var _this3 = this;
    window.addEventListener('resize', this.updateHeight);
    this.$nextTick(function () {
      if (_this3.collapsed) _this3.updateHeight();else _this3.clear();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.updateHeight);
    this.collapseStore.remove(this.id);
  },
  methods: {
    updateHeight: function updateHeight() {
      if (!this.hide && !this.animating) return;
      if (this.$el) this.height = this.$el.scrollHeight + 'px';
    },
    clear: function clear() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.height = 'none';
        _this4.overflow = "visible";
      });
    },
    transitionEnd: function transitionEnd(e) {
      this.animating = false;
      if (e.propertyName == 'max-height' && e.target == e.currentTarget && !this.hide) {
        this.clear();
      }
    },
    setHide: function setHide(val) {
      this.hide = val;
      if (val) this.overflow = 'hidden';
    }
  }
};